import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchDetailsPartConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchDetailsPartStack = createStackNavigator();

const BatchDetailsPartNavigator = () => {
  return (
    <BatchDetailsPartStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchDetailsPartConfig.map(({ Component, name }) => (
        <BatchDetailsPartStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchDetailsPartStack.Navigator>
  );
};

export { BatchDetailsPartNavigator };
